// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Router = require("next/router");

function push(url, scroll, shallow, t) {
  t.push(url, scroll !== undefined || shallow !== undefined ? ({
      scroll: scroll,
      shallow: shallow
    }) : undefined);
}

function replace(url, scroll, shallow, t) {
  t.replace(url, scroll !== undefined || shallow !== undefined ? ({
      scroll: scroll,
      shallow: shallow
    }) : undefined);
}

function prefetch(url, t) {
  t.prefetch(url);
}

function replace$1(url, scroll, shallow) {
  Router.default.replace(url, undefined, scroll !== undefined || shallow !== undefined ? ({
      scroll: scroll,
      shallow: shallow
    }) : undefined);
}

let SingletonRouter = {
  replace: replace$1
};

function Router_query(prim) {
  return prim.query;
}

function Router_pathname(prim) {
  return prim.pathname;
}

function Router_asPath(prim) {
  return prim.asPath;
}

function Router_back(prim) {
  prim.back();
}

function Router_isReady(prim) {
  return prim.isReady;
}

function Router_basePath(prim) {
  return prim.basePath;
}

let Router_Events = {
  on: (prim0, prim1) => {
    prim0.on(prim1.NAME, prim1.VAL);
  },
  off: (prim0, prim1) => {
    prim0.off(prim1.NAME, prim1.VAL);
  },
  emit: (prim0, prim1) => {
    prim0.off(prim1.NAME, prim1.VAL);
  }
};

function Router_events(prim) {
  return prim.events;
}

let Router$1 = {
  push: push,
  replace: replace,
  prefetch: prefetch,
  query: Router_query,
  pathname: Router_pathname,
  asPath: Router_asPath,
  back: Router_back,
  isReady: Router_isReady,
  basePath: Router_basePath,
  Events: Router_Events,
  events: Router_events
};

function useRouter(prim) {
  return Router.useRouter();
}

let Link;

let Head;

let Image;

exports.Router = Router$1;
exports.useRouter = useRouter;
exports.SingletonRouter = SingletonRouter;
exports.Link = Link;
exports.Head = Head;
exports.Image = Image;
/* next/router Not a pure module */
